import {
  employeeListShortService,
  departmentListShortService,
  titleListShortService,
  branchListShortService,
  applicationListShortService,
  roleListShortService,
  featureListShortService,
  tenantListShortService,
  organizationListShortService,
} from "services";

import { ModelName } from "./types";

export const getServices = (
  model: ModelName,
  page: number,
  keyword?: string,
  depField?: number | string
) => {
  const paginationConfig = {
    page: page || 1,
    limit: 50,
    status: 1,
  };
  switch (model) {
    case "employee":
      return employeeListShortService({
        fullName: keyword,
        organizationId: Number(depField) || undefined,
        ...paginationConfig,
      });

    case "department":
      return departmentListShortService({
        name: keyword,
        organizationId: Number(depField) || undefined,
        ...paginationConfig,
      });

    case "title":
      return titleListShortService({
        name: keyword,
        organizationId: Number(depField) || undefined,
        ...paginationConfig,
      });

    case "branch":
      return branchListShortService({
        name: keyword,
        organizationId: Number(depField) || undefined,
        ...paginationConfig,
      });

    case "application":
      return applicationListShortService({
        name: keyword,
        ...paginationConfig,
      });

    case "organization":
      return organizationListShortService({
        name: keyword,
        tenantId: Number(depField) || undefined,
        ...paginationConfig,
      });

    case "role": {
      const depFields = String(depField).split(":");
      const applicationId = depFields?.[0] || 0;
      const organizationId = depFields?.[1] || 0;
      return roleListShortService({
        name: keyword,
        applicationId: applicationId ? Number(applicationId) : undefined,
        organizationId: organizationId ? Number(organizationId) : undefined,
        ...paginationConfig,
      });
    }

    case "feature":
      return featureListShortService({
        name: keyword,
        applicationId: Number(depField) || undefined,
        ...paginationConfig,
      });

    case "tenant":
      return tenantListShortService({
        name: keyword,
        ...paginationConfig,
      });

    default:
      return employeeListShortService({ fullName: keyword });
  }
};
